import discoveryJSONData from '../../data/discovery.json';
import { Platform } from 'react-native';

let device = 'large'
const discoveryAssetMap = {}

function getUniqueID(releaseName, routeName) {
  return getFormattedReleaseName(releaseName)
    .concat("-")
    .concat(getFormattedRouteName(routeName))
}

function getFormattedReleaseName(releaseName) {
  return releaseName.trim().toLowerCase();
}

function getFormattedRouteName(routeName) {
    return routeName.replace("/", "");
}

function getDiscoveryIDs() {
  var discoveryIDs = [];
  var releaseList = Object.keys(discoveryJSONData);
  for (let i = 0; i < releaseList.length; i++) {
    var routeList = Object.keys(discoveryJSONData[releaseList[i]]);
    for (let j = 0; j < routeList.length; j++) {
      discoveryIDs.push(getUniqueID(releaseList[i], routeList[j]));
    }
  }
  return discoveryIDs;
}

function initiateDiscoveryAssets() {
  var discoveryIDs = [];
  var platformType = 'desktop'
  var releaseList = Object.keys(discoveryJSONData);
  for (let i = 0; i < releaseList.length; i++) {
    var routeList = Object.keys(discoveryJSONData[releaseList[i]]);
    for (let j = 0; j < routeList.length; j++) {
      discoveryAssetMap[getUniqueID(releaseList[i], routeList[j])]
        = discoveryJSONData[releaseList[i]][routeList[j]][platformType]
    }
  }
  return discoveryAssetMap;
}

function validateRoute(currentRoute, discoveryHistory) {
  var matchedRoutes = []
  const pageName = getFormattedRouteName(currentRoute);
  var discoveryIDs = getDiscoveryIDs() // viewed platform & pageName
  discoveryIDs.forEach(function(item) {
    if (item.includes(pageName)) {
      matchedRoutes.push(item);
    }
  });
  var newDiscoverIDs = [];
  matchedRoutes.forEach(function(item) {
    if (discoveryHistory.indexOf(item) == -1) {
      newDiscoverIDs.push(item);
    }
  });
  return newDiscoverIDs;
}

// @return { ...platform { small: [], large[] } }
function initAssets () {
  let assets = {}
  Object.keys(json).forEach(version => {
    assets[version] = {}
    Object.keys(json[version]).forEach(route => {
      assets[version][route] = json[version][route].desktop
    })
  })
  return assets
}

function isViewed ({ version='getstarted', platform='desktop', route, history }) {
  const pageName = route.substr(13) // /ebankingweb/, e.g. portfolio
  history.some(e => e.includes(version) && e.includes(platform))
}

export {
  validateRoute,
  getDiscoveryIDs,
  initiateDiscoveryAssets,
  discoveryAssetMap,

  initAssets,
  isViewed,
};
